export const FIVE_MINUTES_MS = 60 * 5 * 1000
